import { IEnumeration } from 'utility-js-enumeration';

declare var Enumeration: IEnumeration;

const MajorExplorerUserActivityNameEnum = {
  EI_INTAKE_INTERESTS_PART_1: {
    viewTitle: 'Major Explorer Survey - Select Activities'
  },
  EI_INTAKE_INTERESTS: {
    viewTitle: 'Major Explorer Survey - Select Subjects'
  },
  EI_INTAKE_GOALS: {
    viewTitle: 'Major Explorer Survey - Select Goals'
  },
  EI_INTAKE_META_MAJORS: {
    viewTitle: 'Major Explorer Survey - Select Career Fields'
  },
  EI_INTAKE_PROGRAM_PICKER: {
    viewTitle: 'Major Explorer Results - Results Page'
  }
};

angular
  .module('major-explorer-data')
  .constant(
    'majorExplorerUserActivityNameEnum',
    Enumeration('majorExplorerUserActivityNameEnum', MajorExplorerUserActivityNameEnum)
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-major-explorer/src/data/types/major_explorer_user_activity_name_enum.ts